module.exports = __webpack_public_path__ + "static/media/dec-404-large.9cea37d7.png";